var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-field',{attrs:{"name":"Рост (см)","value":_vm.height},on:{"update:value":function($event){_vm.height=$event}}}),_c('text-field',{attrs:{"name":"Вес (кг)","value":_vm.weight},on:{"update:value":function($event){_vm.weight=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }